module.exports = __webpack_public_path__ + "static/media/placeholder.dae41e7c.jpg";